import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ITableColumnHeader } from 'src/app/models/table-column-header';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { NavigationService } from 'src/app/providers/navigation.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-all-latest-purchase',
  templateUrl: './all-latest-purchase.component.html',
  styleUrls: ['./all-latest-purchase.component.scss']
})
export class AllLatestPurchaseComponent implements OnInit, OnDestroy {

  latestPurchaseData: any = []
  toshowData:boolean =true
  loader: boolean = false
  _apisub: Subscription
  pageNo:number = 1
  constructor(private navservice:NavigationService,private _apiservice:ApiService,private loaderservice:LoaderServiceService) {this.navservice.hideSidebarAndNav=false
    this._apisub = this._apiservice.apiResult.subscribe(resdata =>{
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_LATEST_PURCHASES_FOR_DASHBOARD){
        this.latestPurchaseData = []
        if(resdata.result){
          this.latestPurchaseData = resdata.result
          this.latestPurchaseData.forEach((element:any) => {
            
            element.purchase_date = element.purchase_status == 2
              ? 'Reminder'
              : new Date(element.purchase_date).toLocaleString('en-US', {
                  timeZone: 'UTC',
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                  hour: 'numeric',
                  minute: '2-digit',
                  hour12: true
                }); 
            element.activity = element.purchase_quantity + ' ' + element.purchase_unit
            element.purchase_price = (element.currency_symbol ? element.currency_symbol : '₹') + (element.purchase_price.toFixed(2))
          });
        }
        this.loaderservice.showLoader = false
        this.loader = false

      }
    })
   }

  ngOnInit(): void {
    this.loaderservice.showLoader = true
    this.loader = true
    this._apiservice.getLatestPurchasesForDashboard('500',this.pageNo)
  }

  // tableDisplayColumns: string[] = ['image', 'name', 'shop', 'payment', 'time', 'assigned', 'status'];
  
  bookingData = [
    { image: 'https://www.bigbasket.com/media/uploads/p/l/20004724_11-pantene-advanced-hair-care-solution-shampoo-lively-clean.jpg', name: 'Shampoo', quanty: '500 ml bottle', shop: 'Mithali Hair Spa',  location: 'Bengal Ambuja Durgapur, West Bengal 713216', date: '2024-07-12', time: '3:00 PM',  stock:'10 Bottle', amount:'999.00' },
    { image: 'https://cdn.thewirecutter.com/wp-content/media/2023/04/sunscreen-2048px-09193.jpg?auto=webp&quality=75&width=1024', name: 'Sunscreens', quanty: '500 ml bottle', shop: 'Mithali Hair Spa',  location: 'Bengal Ambuja Durgapur, West Bengal 713216', date: '2024-07-12', time: '3:00 PM',  stock:'10 Bottle', amount:'1266.00' },
    { image: 'https://m.media-amazon.com/images/I/616kViYpgpL._AC_UF1000,1000_QL80_.jpg', name: 'Eye shadows', quanty: '4 Unit', shop: 'Mithali Hair Spa',  location: 'Bengal Ambuja Durgapur, West Bengal 713216', date: '2024-07-12', time: '3:00 PM',  stock:'20 Unit', amount:'200.00' },
    { image: 'https://cdn.pixelspray.io/v2/black-bread-289bfa/TIw66q/wrkr/t.resize(h:1240,w:1400)/data/Westelm/04Nov2020/7543848_7.jpg', name: 'Towels', quanty: '4 Unit', shop: 'Mithali Hair Spa',  location: 'Bengal Ambuja Durgapur, West Bengal 713216', date: '2024-07-12', time: '3:00 PM',  stock:'10 Bottle', amount:'178.00' },
    { image: 'https://rukminim2.flixcart.com/image/750/900/kxp0mfk0/makeup-apron/o/m/1/set-of-2-pcs-unisex-nylon-waterproof-machine-washable-original-imaga3dgdkjddgt8.jpeg?q=20&crop=false', name: 'Aplon', quanty: '11 Unit', shop: 'Mithali Hair Spa',  location: 'Bengal Ambuja Durgapur, West Bengal 713216', date: '2024-07-12', time: '3:00 PM',  stock:'10 Bottle', amount:'999.00' },
    { image: 'https://www.jpscissors.com/cdn/shop/articles/what-are-the-differences-between-shears-scissors-927962_1200x.jpg?v=1663030248', name: 'Shears and scissors', quanty: '1 Unit', shop: 'Mithali Hair Spa',  location: 'Bengal Ambuja Durgapur, West Bengal 713216', date: '2024-07-12', time: '3:00 PM',  stock:'10 Bottle', amount:'444.00' },
    { image: 'https://rukminim2.flixcart.com/image/850/1000/kj36ky80-0/hair-dryer/w/u/f/3500watt-high-quality-salon-grade-professional-hair-dryer-with-original-imafyqjp3qbrgkfu.jpeg?q=20&crop=false', name: 'Hairdryers', quanty: '500 ml bottle', shop: 'Mithali Hair Spa',  location: 'Bengal Ambuja Durgapur, West Bengal 713216', date: '2024-07-12', time: '3:00 PM',  stock:'10 Unit', amount:'1299.00' },

  ];


  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "name",
      columnProperty: "item_name"
    },
    {
      columnName: "quantity info",
      columnProperty: "quantity_info"
    },
    {
      columnName: "shop",
      columnProperty: "name"
    },
    {
      columnName: "location",
      columnProperty: "address_line"
    },
    {
      columnName: "date",
      columnProperty: "purchase_date"
    },
    // {
    //   columnName: "time",
    //   columnProperty: "time"
    // },
  
    {
      columnName: "purchase quantity",
      columnProperty: "activity"
    },
  
    {
      columnName: "amount",
      columnProperty: "purchase_price"
    }
  ];
  ngOnDestroy(): void {
    this._apisub.unsubscribe()
  }
}
